import * as io from 'io-ts';
import { nullableString, boolean } from '@shared/core/types/common';

const additionalInfoFieldsDefinition: io.MixedObject<OLO.Config.LocationsMoreInfoModalAdditionalFields> = {
    email: boolean,
    phone: boolean,
};

const rootDefinition: io.MixedObject<OLO.Config.LocationsMoreInfoModal> = {
    changeLocationButton: nullableString,
    viewMenuButton: nullableString,
    additionalInfoFields: io.type(additionalInfoFieldsDefinition),
};

export const locationMoreInfoModalSchema = io.type(rootDefinition);
